import { Col, Row } from 'reactstrap';
import { Select, TextInput, SelectOptionType } from '@octano/global-ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useValidations } from '../../../../hooks/useValidations';
import { ContinuousEducationSectionValuesForm } from '../../types/ContinuousEducationSectionForm.types';

interface GeneralFieldsProps {
  campusOptions: SelectOptionType[];
  schedulesOptions: SelectOptionType[];
}

export function ContinuousEducationSectionEditGeneralFields({
  campusOptions,
  schedulesOptions,
}: GeneralFieldsProps) {
  const { t } = useTranslation();
  const { control } = useFormContext<ContinuousEducationSectionValuesForm>();
  const { msgValidations, rulesPatternNumeric } = useValidations();

  return (
    <Row>
      <Col xs={12} md={4}>
        <TextInput
          name="name"
          label={t('sectionsMaintainer.update.sectionName')}
          control={control}
          rules={{ required: msgValidations.required }}
        />
      </Col>
      <Col xs={12} md={4}>
        <TextInput
          name="code"
          label={t('sectionsMaintainer.update.sectionCode')}
          control={control}
          rules={{ required: msgValidations.required }}
        />
      </Col>
      <Col xs={12} md={4}>
        <TextInput
          name="quota"
          label={t('sectionsMaintainer.update.quotaLabel')}
          control={control}
          rules={{
            required: msgValidations.required,
            pattern: rulesPatternNumeric,
          }}
        />
      </Col>
      <Col xs={12} md={4}>
        <Select
          name="campus"
          label={t('sectionsMaintainer.update.campusLabel')}
          options={campusOptions}
          control={control}
          rules={{ required: msgValidations.required }}
        />
      </Col>
      <Col xs={12} md={4}>
        <Select
          name="schedule"
          label={t('sectionsMaintainer.update.schedulesLabel')}
          options={schedulesOptions}
          control={control}
          isClearable
          rules={{ required: msgValidations.required }}
        />
      </Col>
    </Row>
  );
}
